/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PalReauthSubmission } from './PalReauthSubmission';
import {
    PalReauthSubmissionFromJSON,
    PalReauthSubmissionFromJSONTyped,
    PalReauthSubmissionToJSON,
    PalReauthSubmissionToJSONTyped,
} from './PalReauthSubmission';

/**
 * 
 * @export
 * @interface PalReauthSubmissionHistoryResponse
 */
export interface PalReauthSubmissionHistoryResponse {
    /**
     * 
     */
    reauth_submissions: Array<PalReauthSubmission>;
}

/**
 * Check if a given object implements the PalReauthSubmissionHistoryResponse interface.
 */
export function instanceOfPalReauthSubmissionHistoryResponse(value: object): value is PalReauthSubmissionHistoryResponse {
    if (!('reauth_submissions' in value) || value['reauth_submissions'] === undefined) return false;
    return true;
}

export function PalReauthSubmissionHistoryResponseFromJSON(json: any): PalReauthSubmissionHistoryResponse {
    return PalReauthSubmissionHistoryResponseFromJSONTyped(json, false);
}

export function PalReauthSubmissionHistoryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalReauthSubmissionHistoryResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'reauth_submissions': ((json['reauth_submissions'] as Array<any>).map(PalReauthSubmissionFromJSON)),
    };
}

export function PalReauthSubmissionHistoryResponseToJSON(json: any): PalReauthSubmissionHistoryResponse {
    return PalReauthSubmissionHistoryResponseToJSONTyped(json, false);
}

export function PalReauthSubmissionHistoryResponseToJSONTyped(value?: PalReauthSubmissionHistoryResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'reauth_submissions': ((value['reauth_submissions'] as Array<any>).map(PalReauthSubmissionToJSON)),
    };
}

